/**
 * Form module
 * Adds stylable block to checkboxes/radio buttons
 * @module
 */
import toArray from 'arrayify';
import BEM from 'bem.js';


export const BLOCK_CHECKBOX = 'checkbox';

export const BLOCK_RADIO = 'radio';

const BLOCK_LABEL = 'label';

export const MODIFIER_BUTTON = 'button';

const CHECKBOXES = BEM.getBEMNodes(BLOCK_CHECKBOX);

const RADIOS = BEM.getBEMNodes(BLOCK_RADIO);


/**
 * FakeControl class
 * Adds stylable block to checkboxes/radio buttons
 * @class
 */
export class FakeControl {
    /**
     * Constructor method
     * Gets called when class get instantiated
     * @param {NodeList} htmlInputElements
     */
    constructor(htmlInputElements) {
        toArray(htmlInputElements).forEach(this.addStyling.bind(this));
    }

    /**
     * EVERY "htmlInputElement" MUST HAVE AN ID!
     * Adds a fake radio button (label) for htmlInputElement
     * @param {HTMLElement} htmlInputElement
     */
    addStyling(htmlInputElement) {
        let fake = document.createElement('label');
        fake.className = htmlInputElement.className;
        fake.disabled = htmlInputElement.disabled;

        if (BEM.hasModifier(fake, MODIFIER_BUTTON)) {
            let label = toArray(BEM.getBEMNodes(BLOCK_LABEL)).filter((node) => node.htmlFor === htmlInputElement.id)[0];

            if (label) {
                fake.innerText= label.innerText;
                label.parentNode.removeChild(label);
            }
        }

        fake.htmlFor = htmlInputElement.id;
        this.insertAfter(fake, htmlInputElement);
    }

    /**
     * Inserts newNode into the DOM after referenceNode
     * @param {HTMLElement} newNode
     * @param {HTMLElement} referenceNode
     */
    insertAfter(newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
}


new FakeControl(CHECKBOXES);
new FakeControl(RADIOS);



// WEBPACK FOOTER //
// ./src/my_artis/js/components/form.js